import { RemoteGetConsolidatedActivitiesByStudent } from 'data/usecases';
import { GetConsolidatedActivitiesByStudentUseCaseInterface } from 'domain/usecases';
import { makeApiUrlConsolidatedActivitiesByStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetConsolidatedActivitiesByStudent =
  (): GetConsolidatedActivitiesByStudentUseCaseInterface =>
    new RemoteGetConsolidatedActivitiesByStudent(
      makeApiUrlConsolidatedActivitiesByStudent(),
      makeAxiosHttpClient(),
    );
